<template>
    <div class="container">
		<template v-if="applyAccess === 2">
			<div class="access-close">
				<span class="back" @click="goBack">
					&lt; 返回
				</span>
				<div class="top-text">
					感谢您的大力支持 <br>
					期待您下次尽早到来
				</div>
				<div class="center-text">
					活动名额已满
				</div>
				<div class="to-login" @click="goLogin">
					已报名去登录 &gt;&gt;
				</div>
			</div>
		</template>
		<template v-if="applyAccess === 1">
			<div class="left-bar">
				<div class="item" :class="{act: tab == '1'}" @click="tab = '1'">
					<span>个<br>人<br>信<br>息</span>
				</div>
				<div class="item" :class="{act: tab == '2'}" @click="tab = '2'">
					<span>家<br>庭<br>信<br>息</span>
				</div>
				<div class="item" :class="{act: tab == '3'}" @click="tab = '3'">
					<span>邀<br>请<br>队<br>伍</span>
				</div>
			</div>
			<div class="tab-wrap">
				<div class="tab" v-show = "tab == '1'">
					<h4 class="tit">个人信息</h4>
					<div class="block">
						<span class="label">姓名</span>
						<input class="input" type="text" v-model.trim="form.name" placeholder="请输入姓名" @blur="saveToLocal">
					</div>
					<div class="block">
						<span class="label">年龄</span>
						<input class="input" type="tel" v-model.trim="form.age" placeholder="请输入年龄" @blur="saveToLocal">
						<i class="unit">周岁</i>
					</div>
					<div class="block">
						<span class="label">身份证</span>
						<input class="input" v-model.trim="form.idNumber" placeholder="请输入身份证号" @blur="saveToLocal">
					</div>
					<div class="block">
						<span class="label">擅长品类</span>
						<input class="input" type="text" v-model.trim="form.category" readonly @click="showPicker(1)"  placeholder="请点击选择">
						<i class="icon_down"></i>
					</div>
					<div class="block">
						<span class="label">从业时间</span>
						<input class="input" type="tel" v-model.trim="form.workTime" placeholder="请输入从业时间"  @blur="saveToLocal">
						<i class="unit">年</i>
					</div>
					<div class="block">
						<span class="label">年收入</span>
						<input class="input" type="tel" v-model.trim="form.yearIncome" placeholder="请输入年收入"  @blur="saveToLocal">
						<i class="unit">万</i>
					</div>
					<div class="block">
						<span class="label">手机号</span>
						<input class="input" type="tel" maxlength="11" v-model.trim="form.phone" placeholder="请输入手机号"  @blur="saveToLocal">
					</div>
					<div class="block">
						<span class="label">验证码</span>
						<input class="input" type="tel" maxlength="6" v-model.trim="form.code" placeholder="请输入验证码" @blur="saveToLocal">

						<span class="get-code-wrap">
							<span class="get-code" @click="sentCode">{{send ? '发送验证码' : number + 's 后重新发送'}}</span>
						</span>
					</div>
					<div class="button-wrap">
						<button class="button" @click="next(1)">下一步</button>
					</div>
				</div>
				<div class="tab" v-show = "tab == '2'">
					<h4 class="tit">家庭信息</h4>
					<div class="block">
						<span class="label">婚姻状况</span>
						<input class="input" type="text" v-model.trim="form.marryState" readonly @click="showPicker(2)" placeholder="请点击选择">
						<i class="icon_down"></i>
					</div>
					<div class="block">
						<span class="label">子女数量</span>
						<input class="input" type="tel" v-model.trim="form.childNumber" placeholder="请输入子女数量"  @blur="saveToLocal">
					</div>
					<div class="block">
						<span class="label">籍贯</span>
						<input class="input" type="text"  v-model.trim="form.city" readonly @click="showAddressPicker" placeholder="请点击选择" >
						<i class="icon_down"></i>
					</div>
					<div class="block">
						<span class="label textarea-label">现居地址</span>
						<textarea class="input textarea" v-model.trim="form.detailAddress" placeholder="请输入详细地址"  @blur="saveToLocal"></textarea>
					</div>
					<div class="block">
						<span class="label spec">杭州</span>
						<span class="label">居住时间</span>
						<input class="input" type="tel" v-model.trim="form.liveHereTime" placeholder="请输入居住时间"  @blur="saveToLocal">
						<i class="unit">年</i>
					</div>
					<div class="button-wrap">
						<button class="button" @click="next(2)">下一步</button>
					</div>
				</div>
				<div class="tab" v-show = "tab == '3'">
					<h4 class="tit">三人成队伍 勇夺万元奖金</h4>
					<h5 class="sub-tit">队员一</h5>
					<div class="block">
						<span class="label">姓名</span>
						<input class="input" type="text" v-model.trim="form.name1" placeholder="请输入姓名"  @blur="saveToLocal">
					</div>
					<div class="block">
						<span class="label">手机号</span>
						<input class="input" type="tel" maxlength="11" v-model.trim="form.phone1" placeholder="请输入手机号"  @blur="saveToLocal">
					</div>
					<div class="block">
						<span class="label">身份证</span>
						<input class="input" v-model.trim="form.idNumber1" placeholder="请输入身份证号"  @blur="saveToLocal">
					</div>

					<h5 class="sub-tit">队员二</h5>
					<div class="block">
						<span class="label">姓名</span>
						<input class="input" type="text" v-model.trim="form.name2" placeholder="请输入姓名"  @blur="saveToLocal">
					</div>
					<div class="block">
						<span class="label">手机号</span>
						<input class="input" type="tel" maxlength="11" v-model.trim="form.phone2" placeholder="请输入手机号"  @blur="saveToLocal">
					</div>
					<div class="block">
						<span class="label">身份证</span>
						<input class="input" v-model.trim="form.idNumber2" placeholder="请输入身份证号"  @blur="saveToLocal">
					</div>

					<div class="apply-tip">
						对方会收到邀请短信 <br>
						在短信链接中进行受邀确认
					</div>
					
					
					<div class="button-wrap" style="padding-top: 0.4rem;">
						<button class="button" @click="submit">确认报名</button>
					</div>
				</div>
			</div>
		</template>
    </div>
</template>
<script>
import { validateMobile, validateIdCard, validateNumber, validateFloatNumber } from '@/utils/validate'
import { RequestPhoneCode, signUp, checkSignUpPassageway } from '@/api/index'
const column1 = [
	{ text: '职业装', value: '职业装'},
	{ text: '上衣', value: '上衣' },
	{ text: '连衣裙', value: '连衣裙' },
	  
	{ text: '毛衣', value: '毛衣' },
	{ text: 'T恤', value: 'T恤' },
	{ text: '外套', value: '外套' },
	{ text: '旗袍', value: '旗袍' },
	{ text: '礼服', value: '礼服' },
	{ text: '呢料大衣', value: '呢料大衣' },
	{ text: '风衣', value: '风衣' },
	{ text: '卫衣', value: '卫衣' },
	{ text: '皮衣', value: '皮衣' },
	{ text: '连体裤', value: '连体裤' },
	{ text: '棉服', value: '棉服' },
	{ text: '衬衫', value: '衬衫' },
	{ text: '长裤', value: '长裤' },
	{ text: '半裙', value: '半裙' },
	{ text: '短裙', value: '短裙' },
	{ text: '连体裙', value: '连体裙' },
	{ text: '套裤', value: '套裤' },
	{ text: '套裙', value: '套裙' },
	{ text: '西服套装', value: '西服套装' },
	{ text: '家居服', value: '家居服' },
	{ text: '羽绒棉服', value: '羽绒棉服' },
	{ text: 'POLO衫', value: 'POLO衫' },
	{ text: '休闲西服', value: '休闲西服' },
	{ text: '马甲', value: '马甲' },
	{ text: '休闲裤', value: '休闲裤' },
	{ text: '毛呢大衣', value: '毛呢大衣' },
	{ text: '七分裤', value: '七分裤' },
	{ text: '短裤', value: '短裤' },
  ]

const column2 = [
	{ text: '已婚', value: '已婚'},
	{ text: '未婚', value: '未婚' }
  ]

import { provinceList, cityList, areaList } from '@/utils/area'

const addressData = provinceList
addressData.forEach(province => {
  province.children = cityList[province.value]
//   province.children.forEach(city => {
//     city.children = areaList[city.value]
//   })
})

export default {
	name: 'apply',
	data() {
		return {
			tab: '1',
			form: {
				// 个人信息
				name: '',
				age: '',
				idNumber: '',
				category: '',
				workTime: '',
				yearIncome: '',
				phone: '',
				code: '',

				// 家庭信息
				marryState: '',
				childNumber: '',
				city: '',
				detailAddress: '',
				liveHereTime: '',

				// 团队信息
				name1: '',
				phone1: '',
				idNumber1: '',
				name2: '',
				phone2: '',
				idNumber2: '',
			},
			send: true,
			number: 60,
			currentPicker: {
				title: '',
				type: '',
			},
			addressPicker: null,
			applyAccess: ''  
		}
	},
	created() {
		this.getApplyAccess();
		console.log(this.$route)
		console.log(window.history)
	},
	computed: {
		backShow() {
			return window.history.length > 1
		}
	},
	mounted() {
		this.addressPicker = this.$createCascadePicker({
			title: '请选择城市',
			data: addressData,
			onSelect: this.selectAddressHandle,
			onCancel: this.cancelAddressHandle
		})
		if (localStorage.getItem('apply_edit_form')) {
			this.form = JSON.parse(localStorage.getItem('apply_edit_form'));
		}
		console.log(localStorage.getItem('apply_edit_form'))
		
	},
	methods: {
		goBack() {
			if (window.history.length <= 1) {
                this.$router.push({path:'/'})
                return false
            } else {
                this.$router.go(-1)
            }
		},
		goLogin() {
			this.$router.push({path:'/login'})
		},
		getApplyAccess() {
			let loading = this.$createToast({
				time: 0
			})
			loading.show();
			checkSignUpPassageway().then(res => {
				loading.hide();
				console.log(res);
				if (res.errorCode == -10111) {
					this.applyAccess = 2
					console.log(34242)
				} else if (res.errorCode == 200) {
					this.applyAccess = 1
				} else {
					this.$createToast({
						txt: '网络错误',
						type: 'txt'
					}).show()
				}
			}).catch(err => {
				loading.hide();
				this.$createToast({
					txt: '网络错误',
					type: 'txt'
				}).show()
			})
		},
		saveToLocal() {
			localStorage.setItem('apply_edit_form', JSON.stringify(this.form));
		},
		next(index) {
			switch(index) {
				case 1:
					if (this.check1()) {
						this.tab = 2;
					}
					break;
				case 2:
					if (this.check2()) {
						this.tab = 3;
					}
			}
		},
		submit() {
			if (!this.check1()) {
				this.tab = 1;
				return false;
			}
			if (!this.check2()) {
				this.tab = 2;
				return false;
			}
			if (this.check3()) {
				const loading = this.$createToast({
					time: 0,
					txt: '正在提交...',
					mask: true
				})
				loading.show()
				signUp({
					"phone": this.form.phone,
					"code": this.form.code,
					"age": this.form.age,
					"goodAtCategory": this.form.category,
					"yearsOfWork": this.form.workTime,
					"yearOfIncome": this.form.yearIncome,
					"marryStatus": this.form.marryState,
					"numberOfChildren": this.form.childNumber,
					"nativePlace": this.form.city,
					"address": this.form.detailAddress,
					"residenceTimeInHangzhou": this.form.liveHereTime,
					"userDeviceInfo":"pc",
					"userRealname": this.form.name,
					"userIdNumber": this.form.idNumber,

					"phoneForOne": this.form.phone1,
					"userRealnameForOne": this.form.name1,
					"userIdNumberForOne": this.form.idNumber1,

					"userRealnameForTwo": this.form.name2,
					"userIdNumberForTwo": this.form.idNumber2,
					"phoenForTwo": this.form.phone2,
				}).then(res => {
					loading.hide();
                    if(res.errorCode==200){
                        this.$createToast({
                        	txt: '报名成功',
                        	type: 'txt'
                        }).show();
                        this.$store.dispatch('Login', {
                        	token: res.data.token,
                        	userId: res.data.userId
						});
						localStorage.removeItem('apply_edit_form')
						setTimeout(() => {
							this.$router.replace('/certificate')
						}, 1000);
                    }else{
                        this.$createToast({
                        	txt: res.errorMsg,
                        	type: 'txt'
                        }).show();
                    }
				}).catch(err => {
					loading.hide();
					this.$createToast({
						txt: '网络错误',
						type: 'txt'
					}).show();
				})

			}
		},
		sentCode() {
			console.log(process,"process.env.BASE_API",process.env.NODE_ENV, process.env.VUE_APP_URLENV)
			let timer
			if (this.checkPhone() && this.send) {
				this.number = 60
				this.send = !this.send
				timer = setInterval(() => {
					if (this.number > 0) {
						this.number = this.number - 1
					} else {
						this.send = !this.send
						clearInterval(timer)
					}
				}, 1000)
				RequestPhoneCode({phone: this.form.phone}).then((res) => {
					if (res.errorCode == 200) {
						this.$createToast({
							txt: '验证码发送成功',
							type: 'txt'
						}).show();
					} else {
						this.send = !this.send
						clearInterval(timer)
						this.$createToast({
							txt: '验证码发送失败',
							type: 'txt'
						}).show()
					}
				}).catch(err => {
					this.send = !this.send
					clearInterval(timer)
					this.$createToast({
						txt: '验证码发送失败',
						type: 'txt'
					}).show()
					console.log(error)
				})
			}
		},
		// 前端较验手机号
		checkPhone () {
			if (this.form.phone == '') {
				this.$cToast('请输入手机号')
				return false
			}
			if (!validateMobile(this.form.phone)) {
				this.$cToast('手机号格式不正确')
				return false
			}
			return true
		},
		// 前端较验个人信息
		check1 () {
			if (this.form.name == '') {
				this.$cToast('请输入姓名')
				return false
			}
			if (this.form.age == '') {
				this.$cToast('请输入年龄')
				return false
			}
			if (!validateNumber(this.form.age)) {
				this.$cToast('年龄必须为整数')
				return false
			}
			if (this.form.idNumber == '') {
				this.$cToast('请输入身份证号')
				return false
			}
			this.form.idNumber = this.form.idNumber.replace(/\s/g, '').replace(/x/g, 'X');
			let validate = validateIdCard(this.form.idNumber);
			if (!validate.pass) {
				this.$cToast('身份证号码填写错误')
				return false
			}
			if (this.form.category == '') {
				this.$cToast('请选择擅长品类')
				return false
			}
			if (this.form.workTime == '') {
				this.$cToast('请输入从业时间')
				return false
			}
			if (!validateFloatNumber(this.form.workTime)) {
				this.$cToast('从业时间必须为数字')
				return false
			}
			if (this.form.yearIncome == '') {
				this.$cToast('请输入年收入')
				return false
			}
			if (!validateFloatNumber(this.form.yearIncome)) {
				this.$cToast('年收入必须为数字')
				return false
			}
			if (this.form.phone == '') {
				this.$cToast('请输入手机号')
				return false
			}
			if (!validateMobile(this.form.phone)) {
				this.$cToast('手机号格式不正确')
				return false
			}
			if (this.form.code == '') {
				this.$cToast('请输入验证码')
				return false
			}
			return true
		},
		// 前端较验家庭信息
		check2 () {
			if (this.form.marryState == '') {
				this.$cToast('请选择婚姻状况')
				return false
			}
			if (this.form.childNumber == '') {
				this.$cToast('请输入子女数量')
				return false
			}
			if (!validateNumber(this.form.childNumber)) {
				this.$cToast('子女数量必须为整数')
				return false
			}
			if (this.form.city == '') {
				this.$cToast('请输入籍贯')
				return false
			}
			if (this.form.detailAddress == '') {
				this.$cToast('请输入详细地址')
				return false
			}
			if (this.form.liveHereTime == '') {
				this.$cToast('请输入居住时间')
				return false
			}
			if (!validateFloatNumber(this.form.liveHereTime)) {
				this.$cToast('居住时间必须为数字')
				return false
			}
			return true
		},
		// 前端较验团队信息
		check3 () {
			if (this.form.name1 == '') {
				this.$cToast('请输入队员一的姓名')
				return false
			}
			if (this.form.phone1 == '') {
				this.$cToast('请输入队员一的手机号')
				return false
			}
			if (!validateMobile(this.form.phone1)) {
				this.$cToast('队员一的手机号格式不正确')
				return false
			}
			if (this.form.idNumber1 == '') {
				this.$cToast('请输入队员一的身份证号')
				return false
			}
			this.form.idNumber1 = this.form.idNumber1.replace(/\s/g, '').replace(/x/g, 'X');
			let validate1 = validateIdCard(this.form.idNumber1);
			if (!validate1.pass) {
				this.$cToast('队员一的身份证号码填写错误')
				return false
			}
			if (this.form.name2 == '') {
				this.$cToast('请输入队员二的姓名')
				return false
			}
			if (this.form.phone2 == '') {
				this.$cToast('请输入队员二的手机号')
				return false
			}
			if (!validateMobile(this.form.phone2)) {
				this.$cToast('队员二的手机号格式不正确')
				return false
			}
			if (this.form.idNumber2 == '') {
				this.$cToast('请输入队员二的身份证号')
				return false
			}
			this.form.idNumber2 = this.form.idNumber2.replace(/\s/g, '').replace(/x/g, 'X');
			let validate2 = validateIdCard(this.form.idNumber2);
			if (!validate2.pass) {
				this.$cToast('队员二的身份证号码填写错误')
				return false
			}
			return true
		},
		showPicker(type) {
			let column;
			if (type == 1) {
				column = column1;
				this.currentPicker.type = 1
				this.currentPicker.title = '请选择品类'
			}
			if (type == 2) {
				column = column2;
				this.currentPicker.type = 2
				this.currentPicker.title = '请选择婚姻状况'
			}
			// if (!this.picker) {
			this.picker = this.$createPicker({
				title: this.currentPicker.title,
				data: [column],
				onSelect: this.selectHandle,
				onCancel: this.cancelHandle
			})
			// }
			this.picker.show()
		},
		selectHandle(selectedVal, selectedIndex, selectedText) {
			// this.$createDialog({
			// 	type: 'warn',
			// 	content: `Selected Item: <br/> - value: ${selectedVal.join(', ')} <br/> - index: ${selectedIndex.join(', ')} <br/> - text: ${selectedText.join(' ')}`,
			// 	icon: 'cubeic-alert'
			// }).show()
			console.log(selectedVal, selectedIndex, selectedText)
			if (this.currentPicker.type === 1) {this.form.category = selectedVal[0]} 
			if (this.currentPicker.type === 2) {
				this.form.marryState = selectedVal[0];
				if (selectedVal[0] == '未婚') {
					this.form.childNumber = '0';
				}
			}

			this.saveToLocal()
			
		},
		cancelHandle() {
			// this.$createToast({
			// 	type: 'correct',
			// 	txt: 'Picker canceled',
			// 	time: 1000
			// }).show()
		},
		showAddressPicker() {
			this.addressPicker.show()
		},
		selectAddressHandle(selectedVal, selectedIndex, selectedText) {
			// this.$createDialog({
			// 	type: 'warn',
			// 	content: `Selected Item: <br/> - value: ${selectedVal.join(', ')} <br/> - index: ${selectedIndex.join(', ')} <br/> - text: ${selectedText.join(' ')}`,
			// 	icon: 'cubeic-alert'
			// }).show()
			this.form.city = selectedText[0] + selectedText[1];
			this.saveToLocal();
		},
		cancelAddressHandle() {
			// this.$createToast({
			// 	type: 'correct',
			// 	txt: 'Picker canceled',
			// 	time: 1000
			// }).show()
		}
	}
}
</script>


<style scoped>
/* 去掉 input type=number 上下箭头 */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"]{
  -moz-appearance: textfield;
}
.container {
	width: 100%;
	min-height: 100vh;
	background: #242f3c url(../assets/bg.png) no-repeat left bottom/100%;
	overflow: hidden;
	max-width: 768px;
	margin: 0 auto;
	position: relative;
}
.left-bar {
	position: fixed;
	width: 0.9rem;
	height: 100%;
	background: #2e3a48;
	font-size: 0.3rem;
	z-index: 10;
}
.left-bar .item {
	text-align: center;
	height: 33.3%;
	width: 0.9rem;
	box-sizing: border-box;
	border-bottom: 1px solid #2e3a48;
	color: #b1b5be;
	position: relative;
}
.left-bar .item.act {
	background: #b1b5be;
	color: #2e3a48;
}

.left-bar .item:last-child {
	border-bottom: none;
}

.left-bar .item span {
	position: absolute;
	left: 0;
	top: 50%;
	width: 0.9rem;
	margin-top: -0.88rem;
}

.tab-wrap {
	width: 100%;
/*	height: 100%;*/
/*	overflow-y: auto;*/
	box-sizing: border-box;
}
.tab-wrap .tab {
	height: auto;
	padding: 0.1rem 0.4rem 1rem 1.3rem;
	animation: myswitch 0.5s;
	-webkit-animation: myswitch 0.5s;
	position: relative;
}

.tab-wrap .tit {
	height: 1.2rem;
	line-height: 1.2rem;
	font-size: 0.4rem;
	border-bottom: 0.04rem solid #df7a32;
	color: #df7a32;
	font-weight: normal;
	letter-spacing: 2px;
}

.tab-wrap .sub-tit {
	margin-top: 0.2rem;
	font-size: 0.32rem;
	color: #df7a32;
	letter-spacing: 2px;
	position: relative;
	top: 0.4rem;
}


.block {
	position: relative;
	min-height: 0.5rem;
	padding-left: 1.6rem;
	padding-top: 0.5rem;
	box-sizing: border-box;
}

.label {
	position: absolute;
	bottom: 0.02rem;
	left: 0;
	width: 1.36rem;
	height: 0.34rem;
	line-height: 0.34rem;
	font-size: 0.28rem;
	color: #fff;
	overflow: hidden;
	text-align: justify;
	font-weight: bold;
}
.label::after{
	content: ' ';
	display: inline-block;
	width:100%;
	height:0;
}

.label.spec {
	bottom: 0.4rem;
}

.label.textarea-label {
	bottom: 0.72rem;
}


.input {
	height: 0.5rem;
	line-height: 0.5rem;
	font-size: 0.3rem;
	color: #fff;
	padding: 0;
	margin: 0;
	background: transparent;
	width: 100%;
	border: none;
	border-bottom: 1px solid #fff;
	outline: none;
	-webkit-appearance: none;
	border-radius: 0;
}
.input.textarea {
	height: 1rem;
}

.get-code-wrap {
	position: absolute;
	bottom: 0;
	right: 0;
	padding:0 0 0.2rem 0.1rem;
}
.get-code {
	line-height: 1;
	padding: 0.1rem;
	color: #df7a32;
	font-size: 0.24rem;
	border: 1px solid #df7a32;
	border-radius: 0.1rem;
}
.icon_down {
	position: absolute;
	bottom: 0;
	right: 0.1rem;
	border: 0.14rem solid transparent;
	border-top-color: #fff;
	border-top-width: 0.2rem;
}
.unit {
	position: absolute;
	bottom: 0;
	right: 0;
	padding: 0 0.1rem;
	height: 0.5rem;
	line-height: 0.5rem;
	font-size: 0.3rem;
	font-style: normal;
	color: #fff;
}
.get-code.grey {
	color: #999;
	border-color: #999;
}

.apply-tip {
	font-size:  0.28rem;
	color: #ecf0f1;
	margin-top: 0.4rem;
}

.button-wrap {
	padding-top: 1.2rem;
}

.button-wrap .button {
	margin: 0;
	padding: 0;
	width: 2rem;
	height: 0.7rem;
	line-height: 0.7rem;
	text-align: center;
	background: #df7a32;
	border-radius: 0.1rem;
	color: #fff;
	font-size: 0.3rem;
	border: none;
}


@keyframes myswitch
{
	from {opacity: 0; left: 1000px;}
	to {opacity: 1; left: 0;}
}

@-webkit-keyframes myswitch 
{
	from {opacity: 0; left: 1000px;}
	to {opacity: 1; left: 0;}
}


@keyframes mySelect
{
	from {opacity: 0; top: 2000px;}
	to {opacity: 1; left: 0;}
}

@-webkit-keyframes mySelect 
{
	from {opacity: 0; top: 2000px;}
	to {opacity: 1; left: 0;}
}


.success-tip {
	padding: 4.2rem 0.2rem 0;
	text-align: center;
	font-size: 0.6rem;
	letter-spacing: 0.1rem;
	color: #fff;
	line-height: 2;
	background: url(../assets/icon_success.png) no-repeat center 1.2rem/ 5.74rem 2.41rem;
}

.success-tip .tit {
	padding: 0.2rem 0.3rem;
	line-height: 1.5;
	background: #df7a32;
	border-radius: 0.1rem;
	color: #111;
	font-size: 0.36rem;
	border: none;
	letter-spacing: 0.04rem;
}

.select-mask {
	position: fixed;
	top: 2000px;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.5);
	overflow: hidden;
	z-index: 50;
	display: none;
	animation: mySelect 0.5s;
	-webkit-animation: mySelect 0.5s;
}
.select-mask.show {
	display: block;
	top: 0;
}

.select-wrap {
	background: #fff;
	width: 100%;
	position: absolute;
	bottom: 0;
	box-sizing: border-box;
}
.select-wrap .title {
	height: 0.8rem;
	font-size: 0.34rem;
	color: #333;
	line-height: 0.8rem;
	text-align: center;
	background: #f0f0f0;
	border-bottom: 1px solid #eee;
	position: relative;
}

.select-wrap .title .select-close {
	position: absolute;
	right: 0;
	top: 0;
	width: 0.8rem;
	height: 0.8rem;
	text-align: center;
	line-height: 0.8rem;
	font-size: 0.5rem;
	color: #333;
	font-style: normal;
}

.select-list {
	max-width: 768px;
	background: #fff;
	margin: 0 auto;
	padding: 0 0 0 0.3rem;
	box-sizing: border-box;
	min-height: 4rem;
	max-height: 7rem;
	overflow-y: auto;
}
.select-item {
	color: #333;
	text-align: left;
	height: 0.9rem;
	line-height: 0.9rem;
	font-size: 0.34rem;
	border-bottom: 1px solid #eee;
}
.select-item:last-child {
	border-bottom: none;
}
.access-close {
	overflow: hidden;
	width: 100%;
	height: 100%;
	background: url(../assets/access_close_bg.png) no-repeat center bottom;
	background-size: cover;
	position: fixed;
	
}
.access-close .top-text {
	margin-top: 0.4rem;
	text-align: center;
	font-size: 0.6rem;
	font-weight: bold;
	line-height: 0.8rem;
	color: #fff;
	text-shadow: 0px 1px 4px #febd44;
}
.access-close .center-text {
	width: 5.8rem;
	height: 5.4rem;
	margin: 0.4rem auto 0;
	background: url(../assets/access_close_kuang.png) no-repeat;
	background-size: cover;
	font-size: 0.66rem;
	font-weight: bold;
	color: #f15f1e;
	line-height: 5.4rem;
	text-align: center;
}
.access-close .to-login {
	padding: 0.1rem 0;
	color: #474747;
	font-size: 0.3rem;
	width: 3.0rem;
	text-align: center;
	margin: 0.2rem auto 0;
}
.access-close .back {
	font-size: 0.34rem;
	color: #fff;
	margin: 0.3rem 0 0 0.3rem;
	display: inline-block;

	
	/* width: 0.8rem;
	height: 0.8rem;
	border-radius: 50%;
	background:url(../assets/icon_left.png) no-repeat center/0.22rem 0.34rem; */
}

</style>

